<template>
  <div class="modal" id="modal" @click="toggleMenu">
        <div class="box">
        <Settings :downloadsPossible="true" />
      </div>
  </div>
</template>

<script>
import Settings from "./Main";
export default {
  name: "SettingsModal",
  data() {
    return {
      isDropdownVisibil: false,
      downloadsPossible: false
    };
  },
  components: {
    Settings
  },
  computed: {
    modalWidth() {
      if (window.innerWidth <= 575) {
        return "100%";
      } else {
        return "70%";
      }
    },
    isCachingOrDeleting() {
      return (
        this.$store.state.isCachingElements ||
        this.$store.state.isDeletingElements
      );
    },
    isSettingsModalopen() {
    return this.$store.state.isSettingsModalopen;
  },
  },
  methods: {
    chooseLanguage(lang) {
      if (this.chosenLanguages.includes(lang)) {
        this.chosenLanguages = this.chosenLanguages.filter(function(item) {
          return item !== lang;
        });
      } else {
        this.chosenLanguages.push(lang);
      }
    },
    openModal() {
      this.$store.commit("setIsSettingsModalopen", true);
    },
    setDownloadPossible() {
      this.downloadsPossible = true;
    },
    clickedToggleBtn() {
      this.isDropdownVisibil = !this.isDropdownVisibil;
    },
    toggleMenu(e) {
      if (
        e.target.id === "modal" && !this.isCachingOrDeleting
      ) {
        this.$store.commit("setIsSettingsModalopen", false);
      }
    },
    beforeClose(event) {
      if (this.isCachingOrDeleting) {
        event.stop();
      }
    }
  },
  mounted() {
    document.addEventListener("swRegistered", this.setDownloadPossible);
  },
  beforeUnmount() {
    document.removeEventListener("swRegistered", this.setDownloadPossible);
  }
};
</script>

<style scoped>
.box {
  background: white;
}
.modal-settings {
  z-index: 1040;
  height: 100% !important;
  min-height: 100% !important;
  overflow-y: auto;
}
.v--modal-overlay {
  z-index: 1040;
}
.catchClickIfItsOutside {
  position: fixed;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  background-color: transparent;
  z-index: 2;
}
.modal{
  position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

}
</style>
